export default {
    data() {
        return {
            labels: {
                id: '0'
            },
            arr: [

            ],
            tab: [

            ],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            // 是否为父节点
            isParent: true,
            // 父节点
            parentNode: '',
            // 节点名称
            node: ''
        }
    },

    methods: {
        getCheckedNodes() {
            // // console.log('还可以');
            // // console.log(this.$refs.tree.getCheckedNodes());
        },
        //获取类别标签
        getLabel() {
            this.$post('labels/all', { shop_id: this.$store.state.store.id }).then(res => {
                this.arr = []
                let data = res.data.result;
                // // console.log(res)
                // // console.log(data)
                this.labels = {id: 0}
                this.allLabel(data, this.labels);
                this.intercept();
            })
        },
        //递归处理返回的标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id == labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }
            }
        },

        //获取
        intercept() {
            let obj = this.labels.children
            this.arr = obj;
            // // console.log(this.arr)
        },


        // 新建节点的方法
        createNode() {
            let isParent = this.isParent
            let parentNode = this.parentNode
            let node = this.node
            let parent_id = null
            if (node === '') {
                this.$message({
                    type: 'error',
                    message: '节点名称不能为空'
                })
                return
            }
            if (isParent) {
                // 该节点为父节点, parent_id = 0
                parent_id = 0
            } else {
                parent_id = parentNode
            }
            this.$post('labels/create', {
                parent_id: parent_id,
                name: node,
                onsale: 1,
                token: this.$store.state.authority_management,
                shop_id: this.$store.state.store.id
            }).then(res => {
                // // console.log(res)
                if (res.status === 200) {
                    // // console.log('进来了')
                    this.$message({
                        type: 'success',
                        message: '添加成功'
                    })
                    // this.$router.push('labelmanagement')
                    // 复原数据
                    this.isParent = true
                    this.parentNode = ''
                    this.node = ''
                    // 获取标签
                    this.getLabel()
                } else {
                    this.$message({
                        type: 'error',
                        message: '添加失败'
                    })
                }
            })
        },

        // 修改节点的方法
        editNode(node) {
            // // console.log(node)
            this.$confirm(`是否将该节点的名称修改为 "${node.name}"`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('labels/edit', {
                    parent_id: node.parent_id,
                    name: node.name,
                    id: node.id,
                    token: this.$store.state.authority_management
                }).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '修改成功'
                        })
                        //获取标签
                        this.getLabel()
                    } else {
                        this.$message({
                            type: 'info',
                            message: '修改失败'
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消修改'
                })
            })
        },

        // 删除节点的方法
        deleteNode(node) {
            this.$confirm('是否删除该节点', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('labels/delete', {
                    token: this.$store.state.authority_management,
                    id: node.id,
                    onsale: 0
                }).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        //获取标签
                        this.getLabel()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },

        // 修改父节点
        editParentNode(node) {
            // // console.log(node)
            this.editNode(node)
        },

        // 删除父节点
        deleteParentNode(node) {
            // // console.log(node)
            this.deleteNode(node)
        },

        // 修改子节点
        editChildNode(node) {
            // // console.log(node)
            this.editNode(node)
        },

        // 删除子节点
        deleteChildNode(node) {
            // // console.log(node)
            this.deleteNode(node)
        }
    },
    mounted: function () {
        this.getLabel();
        // // console.log(this.$store.state.store.id)
    },
}